import { render } from "./hiddenInput.vue?vue&type=template&id=5771d9fb&scoped=true"
import script from "./hiddenInput.vue?vue&type=script&lang=js"
export * from "./hiddenInput.vue?vue&type=script&lang=js"

import "./hiddenInput.vue?vue&type=style&index=0&id=5771d9fb&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5771d9fb"]])

export default __exports__